/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import urlJoin from 'proper-url-join';

import { generateDocsUrl } from '../../util/docs';
import { getServerBaseUri } from '../../util/url';

export const conversationalSearchGALinks = {
  pricing: {
    ibmCloud: urlJoin(
      getServerBaseUri(),
      'catalog/services/watsonx-assistant?catalog_query=aHR0cHM6Ly9jbG91ZC5pYm0uY29tL2NhdGFsb2c%2Fc2VhcmNoPXdhdHNvbnglMjUyMGFzc2lzdGFudCNzZWFyY2hfcmVzdWx0cw%3D%3D&planId=f0a3dd47-b693-4d73-a8df-aa6baf07a933'
    ),
    wxo: 'https://www.ibm.com/products/watsonx-orchestrate/pricing'
  },
  terms: {
    ibmCloud:
      'https://www.ibm.com/support/customer/csol/terms/?id=i128-0038&lc=en',
    wxo: 'https://www.ibm.com/support/customer/csol/terms/?ref=i126-9451-11-01-2024-zz-en'
  },
  verbosity: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-conversational-search#tuning-the-generated-response-length-in-conversational-search'
  )
};
